module.exports = __webpack_public_path__ + "img/back_icon.6b0ef00e.svg";